import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { getProposalUploadURL } from 'api/operations/proposalServiceV3';
import ProposalDomainModule from 'store/modules/proposal/proposalDomainModule';
import { uploadFiles } from 'global/utils/uploadFiles';
import { IStepController } from './iStepController';

interface DomainParams {
  proposalDomainModule: ProposalDomainModule;
}

export default class SecondStepController extends IStepController {
  private _uploadedFile: AcceptedFiles = {};
  private _proposalDomainModule: ProposalDomainModule;

  get isValid(): boolean {
    return Object.keys(this._uploadedFile).length > 0;
  }

  get uploadedFile(): AcceptedFiles {
    return this._uploadedFile;
  }

  public setUploadedFile(file: AcceptedFiles): void {
    this._uploadedFile = file;
  }

  async completeStep(catalogId: string): Promise<void> {
    const uploadedFileName = Object.keys(this._uploadedFile)[0];

    const uploadURL = await getProposalUploadURL(
      {
        domainId: this._proposalDomainModule.sponsorId,
        catalogId,
        cart: this._proposalDomainModule.proposalDomainData!.cart,
        portfolios: this._proposalDomainModule.proposalDomainData!.portfolios,
        period: this._proposalDomainModule.proposalDomainData!.enrollmentPeriod,
        group: this._proposalDomainModule.proposalDomainData!.group,
      },
      uploadedFileName,
    );
    await runInAction(async () => {
      await uploadFiles(this._uploadedFile, { [uploadedFileName]: uploadURL });
    });
  }

  constructor(domainParams: DomainParams) {
    super();
    this._proposalDomainModule = domainParams.proposalDomainModule;
    makeObservable<SecondStepController, '_uploadedFile'>(this, {
      _uploadedFile: observable,
      isValid: computed,
      uploadedFile: computed,
      setUploadedFile: action.bound,
      completeStep: action.bound,
    });
  }
}
